module.exports = __webpack_public_path__ + "static/media/flecha_volver.04147d83.svg";